import { ParentDropTargetIndicator } from './ParentDropTargetIndicator';
import {
  isComponentItemProps,
  isCreateComponentItemProps,
  isScenarioItemProps,
  isWorkspaceItemProps,
  NavigatorContentProps,
} from './PropTypes';
import { LayoutBoxesContainer } from './Atoms';

const NavigatorContent = ({
  name,
  isMultiselectable,
  renderProps,
  navigatorContentStyle,
  parentDropTargetIndicatorStyle,
  layoutBoxesContainerStyle,
  components,
  navigatorContentId,
  navigatorContentClassName,
}: NavigatorContentProps) => (
  <div
    id={navigatorContentId}
    className={navigatorContentClassName}
    style={navigatorContentStyle}
    role="tree"
    tabIndex={0}
    aria-label={name}
    aria-multiselectable={isMultiselectable ? 'true' : 'false'}
  >
    <LayoutBoxesContainer style={layoutBoxesContainerStyle}>
      {renderProps.map(candidate => {
        if (isComponentItemProps(candidate)) {
          const ItemRenderer = components.ComponentItem;
          return <ItemRenderer {...candidate} key={candidate.nodeId} />;
        }
        if (isWorkspaceItemProps(candidate)) {
          const ItemRenderer = components.WorkspaceItem;
          return <ItemRenderer {...candidate} key={candidate.nodeId} />;
        }
        if (isScenarioItemProps(candidate)) {
          const ItemRenderer = components.ScenarioItem;
          return <ItemRenderer {...candidate} key={candidate.nodeId} />;
        }
        if (isCreateComponentItemProps(candidate)) {
          const ItemRenderer = components.CreateComponentItem;
          return ItemRenderer ? (
            <ItemRenderer {...candidate} key={candidate.nodeId} />
          ) : null;
        }
        return null;
      })}
    </LayoutBoxesContainer>
    {parentDropTargetIndicatorStyle && (
      <ParentDropTargetIndicator
        parentDropTargetIndicatorStyle={parentDropTargetIndicatorStyle}
      />
    )}
  </div>
);

export { NavigatorContent };
